export const MOVE = 'Move...';
export const INVITE_TO_EDIT = 'Invite to edit...';
export const MAKE_PUBLIC = 'Make public';
export const MAKE_PRIVATE = 'Make private';
export const STAR = 'Star';
export const UNSTAR = 'Unstar';
export const RENAME = 'Rename';
export const DUPLICATE = 'Duplicate';
export const ARCHIVE = 'Archive';
export const UNARCHIVE = 'Unarchive';
export const DELETE = 'Delete';
export const DOWNLOAD = 'Download';
export const DOWNLOAD_DISABLED_TEXT = 'Preparing download...';
export const DOWNLOAD_DISABLED_TOOLTIP =
  "It'll take a little while before this video is ready to download. Hang tight.";
export const COPY_LINK = 'Copy link';
export const SHARE_WITH_TEAM = 'Share with Team Library';
export const MOVE_PERSONAL_LIBRARY = 'Stop sharing with Team Library';
export const TRANSCRIPT = 'View transcript (n)';
export const REVIEW_TRANSCRIPT = 'Review transcript (n)';
export const SHARE = 'Share';
export const DIVE = 'Dive (Admin)';
export const PIN_TO_PROFILE = 'Pin to profile';
export const UNPIN_FROM_PROFILE = 'Unpin from profile';
export const PIN_HELPER_TEXT = 'Post before pinning to profile';
export const POST = 'Post';
export const UNPOST = 'Unpost';

export const ORDER = [
  MOVE,
  INVITE_TO_EDIT,
  MAKE_PUBLIC,
  STAR,
  UNSTAR,
  RENAME,
  DUPLICATE,
  ARCHIVE,
  UNARCHIVE,
  DOWNLOAD,
  DELETE,
  SHARE_WITH_TEAM,
  MOVE_PERSONAL_LIBRARY,
  TRANSCRIPT,
  SHARE,
  DIVE,
  PIN_TO_PROFILE,
  UNPIN_FROM_PROFILE,
];
